import React, { useEffect, Fragment, useState } from 'react';
import { Card, Form, Input, Radio, DatePicker, Button, Icon, Modal, InputNumber, message } from 'antd';
import 'braft-editor/dist/index.css'
import 'braft-extensions/dist/table.css'
import styles from './index.less';
import BraftEditor from 'braft-editor'
import OSS from 'ali-oss';
import config from '@/utils/config';
import moment from 'moment'
import ImageCutUpload from '../../../../components/ImageCutUpload'

const { OSSConfig } = config
const { TextArea } = Input;

const UNIT_MB = 1024 * 1024;
const MEDIA_SETTINGS = {
  "image/*": {
    tag: "img",
    // fileLimit: UNIT_MB,
    title: "图片"
  },
  "audio/*": {
    tag: "audio",
    fileLimit: 5 * UNIT_MB,
    title: "音频"
  },
  "video/*": {
    tag: "video",
    fileLimit: 100 * UNIT_MB,
    title: "视频"
  }
};

const rowFormItemLayout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 21,
  },
}

const evaluationAnalysis = [
  {
    value: '亲子关系紧张',
    label: '亲子关系紧张'
  }, {
    value: '缺乏安全感',
    label: '缺乏安全感'
  }, {
    value: '焦虑状态较重',
    label: '焦虑状态较重'
  }, {
    value: '内心封闭',
    label: '内心封闭'
  }, {
    value: '阳光积极',
    label: '阳光积极'
  }
]

const controls = [
  'font-size', 'font-family', 'line-height', 'text-align', 'media', 'table', 'component'
]

const client = new OSS(OSSConfig);

const uploadPath = (path, file) => {
  return `${path}/${file.name.split('.')[0]}-${file.uid}.${file.type.split('/')[1]}`;
};

const UploadToOss = (self, path, file) => {
  const url = uploadPath(path, file);
  return new Promise((resolve, reject) => {
    client
      .multipartUpload(url, file)
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
};



//  判断数字
const regPos = /^\d+(\.\d+)?$/;

const PForm = ({
  taskDetail,
  info = {},
  form,
  onOk,
  onCancel,
  ...modalProps
}) => {
  const { getFieldDecorator, validateFields, setFieldsValue, getFieldValue } = form;

  const [count, setCount] = useState(1)
  const [disabled, setDisabled] = useState(false)


  useEffect(() => {

  }, [taskDetail]);

  const myUploadFn = (param) => {
    let file = param.file
    file.uid = `rc-upload-${param.id}`
    const xhr = new XMLHttpRequest
    const fd = new FormData()

    let reader = new FileReader();
    const folder = '';

    reader.readAsDataURL(file);
    reader.onloadend = () => {
      UploadToOss(this, folder, file)
        .then(data => {
          return data;
        })
        .then(data => {
          let src = data.res.requestUrls[0];
          src = src.indexOf('?') > -1 ? src.substr(0, src.indexOf('?')) : src;
          param.success({
            url: src,
          })
        });
    };
  }

  useEffect(() => {
    console.log(info)
    if (info.count) {
      setCount(info.count)
    }
    if (info.paint) {
      setFieldsValue({ paint: BraftEditor.createEditorState(info.paint) })
    } else {
      setFieldsValue({ paint: BraftEditor.createEditorState(null) })
    }
    if (info.supplementInfo) {
      setFieldsValue({ supplementInfo: BraftEditor.createEditorState(info.supplementInfo) })
    } else {
      setFieldsValue({ supplementInfo: BraftEditor.createEditorState(null) })
    }
  }, [info]);


  const handleOk = () => {
    validateFields((errors, values) => {
      const { paint, supplementInfo, documentDate, ...other } = values;
      if (paint.toHTML().length > 15000) {
        Modal.error({
          title: '绘画作品字数过多！',
        });
        return;
      }
      if (supplementInfo.toHTML().length > 15000) {
        Modal.error({
          title: '其他情况记录补充字数过多！',
        });
        return;
      }
      if (errors) return;
      const params = {
        ...other,
        documentDate: documentDate ? Date.parse(documentDate) : undefined,
        paint: paint ? paint.toHTML() : undefined,
        supplementInfo: supplementInfo ? supplementInfo.toHTML() : undefined,
        taskId: taskId,
        customerId: customerId,
        count,
        id: info.id || null,
      }
      onOk(params)
    });
  }

  const { customerId, taskResps } = taskDetail
  const taskId = (taskResps.find(_ => _.serviceVo.taskType === 'evaluation_and_testing' && _.serviceVo.code === 'hhysfxjlb') || {}).id

  const formTitle = (
    <div className={styles.modalHeader}>
      <div className="modal-left">绘画影射分析记录表</div>
      <div className="modal-right">
        <Button
          type="primary"
          // loading={btnLoading} 
          onClick={() => handleOk()}
          style={{ marginRight: 12 }}
        >
          <Icon type="save" /> 保存
        </Button>
        <Button onClick={() => onCancel()}>取消</Button>
      </div>
    </div>
  )

  // 添加附件
  const onImgChange = (url) => {
    if (url) {
      let imageArray = getFieldValue('imageArray')
      imageArray.push(url)
      setFieldsValue({ 'imageArray': imageArray })
    }
  }
  // 删除附件
  const delImageArray = (url) => {
    let imageArray = getFieldValue('imageArray')
    const index = imageArray.findIndex(i => i == url)
    imageArray.splice(index, 1)
    setFieldsValue({ 'imageArray': imageArray })
  }

  return (
    <Modal
      {...modalProps}
      className={styles.modal}
      closable={false}
      title={formTitle}
    // style={{top: 0}}
    >
      <div className={styles['painting']}>
        {/* <div className='painting_btn'>
        {disabled && <Button type='primary' onClick={() => setDisabled(false)}>编辑</Button>}
        {!disabled && <Button type='primary' onClick={() => handleOk()}>保存</Button>}
        <Button type='primary' style={{ marginLeft: 15 }} onClick={() => handPrint()}>打印预览</Button>
      </div> */}
        <div className='contain'>
          <div className='title'>绘画影射分析记录表</div>
          <Form labelAlign='left'>
            <Card type="inner" bordered={false} className={styles.innerCard} size="small" title="基本信息"
              extra={<span>第<InputNumber disabled={disabled} value={count} min={1} max={100} precision={0} onChange={e => setCount(parseInt(e))} size="small" style={{ width: 60, margin: '0 8px', textAlign: 'center' }}></InputNumber>次</span>}
            >
              <Form.Item label='评估分析结果' {...rowFormItemLayout}>
                {getFieldDecorator('evaluationAnalysisResult', {
                  initialValue: info.evaluationAnalysisResult,
                  rules: [{ required: true, message: '必填项' }],
                })(<Radio.Group disabled={disabled}>
                  {evaluationAnalysis.map(_ => <Radio value={_.value}>{_.label}</Radio>)}
                </Radio.Group>)}
              </Form.Item>
              <Form.Item label='日期和时间' {...rowFormItemLayout}>
                {getFieldDecorator('documentDate', {
                  initialValue: info.documentDate ? moment(info.documentDate) : moment(new Date())
                })(<DatePicker disabled={disabled} />)}
              </Form.Item>
            </Card>
            <Card type="inner" bordered={false} className={styles.innerCard} size="small" title="训练记录信息">
              <Form.Item label='阶段目标' {...rowFormItemLayout}>
                {getFieldDecorator('stageGoal', {
                  initialValue: info.stageGoal
                })(<Input maxLength={100} disabled={disabled} />)}
              </Form.Item>
              <Form.Item label='本次目标' {...rowFormItemLayout}>
                {getFieldDecorator('theTarget', {
                  initialValue: info.theTarget
                })(<TextArea maxLength={1000} disabled={disabled} autoSize={{ minRows: 3, maxRows: 8 }} />)}
              </Form.Item>
              <Form.Item label='绘画作品' {...rowFormItemLayout}>
                {getFieldDecorator('paint', {
                  initialValue: info.paint ? BraftEditor.createEditorState(info.paint) : BraftEditor.createEditorState(null),
                  rules: [{
                    validator: (_, value, callback) => {
                      if (value.toHTML().length > 15000) {
                        callback('字数过多！')
                      } else {
                        callback()
                      }
                    }
                  }]
                })(<BraftEditor
                  readOnly={disabled}
                  controls={controls}
                  contentStyle={{ height: 'auto', maxHeight: 800, border: '1px solid #d9d9d9' }}
                  id='editor-1'
                  media={{ uploadFn: myUploadFn }}
                />)}
              </Form.Item>
              <Form.Item label='解读分析' {...rowFormItemLayout}>
                {getFieldDecorator('interpretationOfTheAnalysis', {
                  initialValue: info.interpretationOfTheAnalysis
                })(<TextArea maxLength={1000} disabled={disabled} autoSize={{ minRows: 5, maxRows: 10 }} />)}
              </Form.Item>
              <Form.Item label='特别事件' {...rowFormItemLayout}>
                {getFieldDecorator('specialEvent', {
                  initialValue: info.specialEvent
                })(<TextArea maxLength={1000} disabled={disabled} autoSize={{ minRows: 3, maxRows: 8 }} />)}
              </Form.Item>
              <Form.Item label='问题困扰' {...rowFormItemLayout}>
                {getFieldDecorator('problems', {
                  initialValue: info.problems
                })(<TextArea maxLength={1000} disabled={disabled} autoSize={{ minRows: 3, maxRows: 8 }} />)}
              </Form.Item>
              <Form.Item label='预留作业' {...rowFormItemLayout}>
                {getFieldDecorator('reservedHomework', {
                  initialValue: info.reservedHomework
                })(<TextArea maxLength={1000} disabled={disabled} autoSize={{ minRows: 3, maxRows: 8 }} />)}
              </Form.Item>
              <Form.Item label='其他情况记录补充' {...rowFormItemLayout}>
                {getFieldDecorator('supplementInfo', {
                  initialValue: info.supplementInfo ? BraftEditor.createEditorState(info.supplementInfo) : BraftEditor.createEditorState(null),
                  rules: [{
                    validator: (_, value, callback) => {
                      if (value.toHTML().length > 15000) {
                        callback('字数过多！')
                      } else {
                        callback()
                      }
                    }
                  }]
                })(<BraftEditor
                  readOnly={disabled}
                  controls={controls}
                  contentStyle={{ height: 'auto', maxHeight: 800, border: '1px solid #d9d9d9' }}
                  id='editor-2'
                  media={{ uploadFn: myUploadFn }}
                />)}
              </Form.Item>
            </Card>
            <Card type="inner" bordered={false} className={styles.innerCard} size="small" title="图片附件">
              <Col span={24}>
                <ImageCutUpload OSSConfig={OSSConfig} changeSrc={onImgChange} disabled={disabled} />
                {getFieldDecorator('imageArray', { initialValue: info.imageArray })(<Input style={{ display: 'none' }} />)}
                {
                  getFieldValue('imageArray') && getFieldValue('imageArray').map(it => {
                    return <div style={{ position: 'relative' }}>
                      {
                        !disabled &&
                        <Button onClick={() => delImageArray(it)} style={{ position: 'absolute', left: 0, top: 0 }} type="danger" size='small'>删除</Button>
                      }
                      <img style={{ border: '2px dashed #ccc', marginBottom: 10, maxWidth: 800 }} src={it} />
                    </div>
                  })
                }
              </Col>
            </Card>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

const Painting = Form.create()(PForm)
export default Painting
